import ArticleIcon from "@mui/icons-material/Article";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { Box, Typography } from "@mui/material"


import StatDisplay from "./StatDisplay";
import { formatNumber } from "../../../helpers/leadsManagement";
import ScoreIcon from "../../../icons/ScoreIcon";
import TiktokIcon from "../../../icons/TikTokIcon";
import { SocialInsight } from "../../../types/leads.types";

interface Props {
    categoryData: SocialInsight | null;
    onClick?: () => void;
    isLastIndex?: boolean;
}


const SocialCategoryCard = ({
    categoryData,
    onClick,
}: Props) => {

    return (
        <Box
            onClick={onClick}
            sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                flexWrap: "wrap",
                width: "100%",
                minWidth: "300px",
                // width:"300px",
                gap: 1,
                cursor: onClick ? "pointer" : "default",
                "&:hover": onClick ? {
                    opacity: 0.8,
                    transform: "scale(1.05)",
                    transition: "all 0.2s ease"
                } : {}
            }}
        >
            {/* Card with orange background */}
            <Box sx={{
                width: "100%",
                height: "250px",
                backgroundColor: "#E87722",
                borderRadius: "20px",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                overflow: "visible",
                gap: 0.5,
                padding: "12px",
                boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                transition: "all 0.3s ease",
            }}>
                <Box sx={{ maxWidth: "40px", maxHeight: "40px", display: "flex", alignItems: "center", justifyContent: "center" }}>
                    <TiktokIcon />
                </Box>
                <Typography
                    sx={{
                        textAlign: "center",
                        fontWeight: 700,
                        color: "#ffffff",
                        fontSize: "36px",
                        lineHeight: 1.1,
                        marginTop: "8px",
                        marginBottom: "4px",
                        wordBreak: "break-word",
                        hyphens: "auto"
                    }}
                >
                    {categoryData?.category}
                </Typography>
                <Box
                    sx={{
                        textAlign: "center",
                        fontWeight: 700,
                        color: "#ffffff",
                        fontSize: "16px",
                        display: "flex",
                        flexDirection: "column",
                        gap: 1.5
                    }}
                >
                    <StatDisplay
                        icon={<VisibilityIcon sx={{ fontSize: 24, color: "#ffffff" }} />}
                        label="Views"
                        value={formatNumber(categoryData?.views || 0)}
                    />
                    <StatDisplay
                        icon={<ArticleIcon sx={{ fontSize: 24, color: "#ffffff" }} />}
                        label="Posts"
                        value={formatNumber(categoryData?.posts || 0)}
                    />
                    <StatDisplay
                        icon={<ScoreIcon width={24} height={24} fill="#ffffff" />}
                        label="Score"
                        value={categoryData?.relevanceAssessmentScore || "N/A"}
                    />
                </Box>
            </Box>
        </Box>
    )
}

export default SocialCategoryCard;